import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { Tooltip, Pagination } from "antd";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { BsCheckCircleFill } from "react-icons/bs";
import { CgCreditCard } from "react-icons/cg";
import {
  FaListOl,
  FaRegCheckCircle,
  FaRegUserCircle,
  FaUser,
} from "react-icons/fa";
import { FiAlertTriangle, FiClock } from "react-icons/fi";
import { IoMdSearch, IoMdClose, IoIosArrowForward } from "react-icons/io";
import { MdInfoOutline, MdKeyboardArrowRight } from "react-icons/md";
import { RiTimerLine } from "react-icons/ri";
import ReactInputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { usePopup } from "../../Context/hasPopupActiveContext";
import { usePermissions } from "../../Context/permissionContext";
import { useAuth } from "../../hooks/AuthProvider";
import { useClient } from "../../hooks/ClientProvider";
import ResetPasswordModal from "../../pages/solicitation/ResetPasswordModal";
import api from "../../services/api";
import { cardProcessorService } from "../../services/cardProcessorService";
import { LogsService } from "../../services/logsService";
import { SolicitationService } from "../../services/solicitationService";
import { capitalize } from "../../utils/capitalize";
import { decrypt } from "../../utils/crypto";
import { customerStatus } from "../../utils/customerStatus";
import { formatCPF } from "../../utils/formatter";
import { formatDateTime } from "../../utils/formatDate";
import { notifyError, notifyInfo } from "../../utils/notifications";
import {
  validaCpf,
  validarCNPJ,
  isValidCnpjPortadorBusca,
} from "../../utils/validations";
import Can from "../Can";
import LoadingElevaty from "../LoadingElevaty";
import ModalRequestHome from "../ModalRequestHome";
import PopupService from "../PopupService";
import { TRANSLATE_PRIORITY } from "../Priority";
import { TRANSLATE_STATUS } from "../Status";
import TableRequestsHome from "../TableRequestsHome";
import { InvoiceInfo } from "./InvoiceInfo/InvoiceInfo";
import * as Style from "./style";
import DSButton from "../DSButton";
import { formatClientData } from "./utils";
import { PendingTicketInfoModal } from "../../components-v2/PendingTicketInfoModal";
import { storageService } from "../../services/storageService";
import usePermissionsManagement from "../../pages/PermissionsManagement/usePermissionManagement";
import usePushManagement from "../../pages/PushManagement/usePushManagement";
import { useAttendanceLimit } from "../../hooks/useAttendanceLimit";

const MAPPED_ERROR_MESSAGES = [
  "O cliente titular informado está marcado como cancelado.",
  "O cliente titular informado está marcado como inativo.",
  "O cliente informado não possui cartão.",
];

function SearchUser() {
  const navigate = useNavigate();
  const { client, updateClient } = useClient();
  const { user } = useAuth();
  const { hasPopupActive, handleClosePopup } = usePopup();
  const { permissions, fetchPermissions } = usePermissions();
  const isPasswordExpired = useMemo(
    () => storageService.getPasswordExpired(),
    []
  );

  const [currentClient, setCurrentClient] = useState("titular");
  const [currentDoc, setCurrentDoc] = useState("multSearchValue");

  const [findUser, setFindUser] = useState(false);
  const [clientProducts, setClientProducts] = useState([]);
  const [cardSelected, setCardSelected] = useState();
  const [loadingSearchUser, setLoadingSearchUser] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [loadingClient, setLoadingClient] = useState(false);
  const [clientFound, setClientFound] = useState({});
  const [clientInformation, setClientInformation] = useState({});
  const [dataQuestions, setDataQuestions] = useState(null);
  const [modalAlterarSenhaisOpen, setModalAlterarSenhaisOpen] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [clientsByName, setClientsByName] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalByName, setTotalByName] = useState(0);

  const [modalRequestHomeOpen, setModalRequestHomeOpen] = useState(false);

  const [dataSource, setDataSource] = useState({});
  const [loadingRequestTable, setLoadingRequestTable] = useState(true);
  const [dataRequestByUser, setDataRequestByUser] = useState();
  const [dataModalRequest, setDataModalRequest] = useState();
  const [isLoadingAttend, setIsLoadingAttend] = useState(false);
  const [pendingTicketModalInfo, setPendingTicketModalInfo] =
    useState(undefined);

  const { checkLimit, LimitModal } = useAttendanceLimit();
  const { fetchPermissionsManagement } = usePermissionsManagement();
  const { fetchPermissions: fetchPushPermissions } = usePushManagement();

  const formikRef = useRef();
  const searchInFlightRef = useRef(false);
  const productInFlightRef = useRef(false);

  const toCleanDoc = useCallback(
    (doc) => String(doc ?? "").replace(/[^a-zA-Z0-9]/g, ""),
    []
  );

  const handleOpenModalRequestHome = (e) => {
    setDataModalRequest(e);
    setModalRequestHomeOpen(true);
  };

  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [product, setProduct] = useState({});

  const handleQ1 = useCallback((event) => {
    const { value } = event.target;
    setQ1(value);
  }, []);

  const handleQ2 = useCallback((event) => {
    const { value } = event.target;
    setQ2(value);
  }, []);

  const placeholderText = useMemo(() => {
    if (currentDoc === "client_id") return "Digite o número do ID do Cliente";
    if (currentDoc === "name") return "Digite o nome do cliente";

    if (user?.allowFetchByCard) {
      if (currentClient === "titular") {
        return "Digite o CPF, CNPJ, RG ou Nº do Cartão";
      }
      if (currentClient === "adicional") {
        return "Digite o CPF ou Nº do Cartão";
      }
    }

    if (!user?.allowFetchByCard) {
      if (currentClient === "adicional") {
        return "Digite o CPF";
      }
    }

    return "Digite o CPF, CNPJ ou RG";
  }, [currentDoc, currentClient, user?.allowFetchByCard]);

  const openModalAlterarSenhaisOpen = useCallback(() => {
    setModalAlterarSenhaisOpen(true);
  }, []);

  const closeModalAlterarSenhaisOpen = useCallback(() => {
    setModalAlterarSenhaisOpen(false);
  }, []);

  const handleCleanSearch = () => {
    setFindUser(false);
    setShowClient(false);
    setClientFound({});
    setClientProducts({});
    setCardSelected(null);
  };

  const handleTab = useCallback((doc) => {
    setShowClient(false);
    setCurrentDoc(doc);
    if (formikRef.current) {
      formikRef.current.setFieldError("doc", undefined);
      formikRef.current.setFieldTouched("doc", false, false);
    }
  }, []);

  const handleTypeClient = useCallback(
    (value) => {
      setCurrentClient(value);
      handleCleanSearch();
      setCurrentDoc("multSearchValue");
      handleTab("multSearchValue");
    },
    [currentClient]
  );

  const schema = useMemo(() => {
    return Yup.object().shape({
      doc: Yup.string()
        .required("Campo obrigatório")
        .test("test_doc", "Documento inválido", (value) => {
          if (
            !value ||
            (typeof value !== "string" && typeof value !== "number")
          ) {
            return false;
          }
          if (currentDoc === "name" || currentDoc === "client_id") return true;

          const clean = value.replace(/\D/g, "");

          if (!user?.allowFetchByCard && clean.length > 14) {
            return false;
          }

          if (currentClient === "titular" && clean.length === 14)
            return validarCNPJ(clean);

          const cleanAlfanumericDoc = value.replace(/[^a-zA-Z0-9]/g, "");
          if (
            currentClient === "titular" &&
            cleanAlfanumericDoc.length === 14 &&
            /^[0-9A-Za-z]{14}$/.test(cleanAlfanumericDoc) &&
            /[a-zA-Z]/.test(cleanAlfanumericDoc)
          ) {
            return isValidCnpjPortadorBusca(value);
          }

          if (clean.length === 11) return validaCpf(clean);

          if (clean.length >= 16)
            return clean.length === 16 || clean.length === 19;

          if (clean.length >= 3 && clean.length <= 9) return true;

          return false;
        }),
    });
  }, [currentDoc, currentClient, user?.allowFetchByCard]);

  const handleProduct = useCallback(
    async (value) => {
      if (value !== "none") {
        if (productInFlightRef.current) return;
        productInFlightRef.current = true;

        setCardSelected(value);

        const productSelected = value;

        setProduct(productSelected);
        setShowClient(true);
        setLoadingClient(true);

        const clientId = productSelected?.idTitular ?? productSelected?.id;

        let productWithFlags = productSelected;
        try {
          const clientHorizon = await cardProcessorService.getClientId(clientId);
          const produto = clientHorizon?.produto ?? {};
          productWithFlags = {
            ...productSelected,
            isProdutoDigital: produto.isProdutoDigital,
            isProdutoBandeirado: produto.isProdutoBandeirado,
          };
        } catch (error) {
          console.error("Erro ao carregar flags do produto:", error);
        }

        setProduct(productWithFlags);

        await api
          .get("client_id", {
            client_id: clientId,
            product_id: productSelected.codigoProduto,
          })
          .then((res) => {
            if (productSelected.idTitular) {
              res.data.adicional?.map((aditional) => {
                if (aditional.id === productSelected.id) {
                  setDataQuestions(aditional.nascimento);
                }
                return true;
              });
            }
            setClientInformation(res.data.information);
            setClientFound(res.data);
            setTimeout(() => {
              setLoadingClient(false);
              productInFlightRef.current = false;
              searchInFlightRef.current = false;
            }, 1000);
          })
          .catch((error) => {
            productInFlightRef.current = false;
            searchInFlightRef.current = false;
            notifyError("Erro ao selecionar produto", error.message);
            console.log(error.response);
          });
      }
    },
    [clientProducts, product]
  );

  const handleSelectCliente = useCallback(async (id, fromActiveSearch = false) => {
    if (productInFlightRef.current) return;
    if (!fromActiveSearch && searchInFlightRef.current) return;

    searchInFlightRef.current = true;
    setClientsByName({});
    setLoadingSearchUser(true);
    await api
      .get(`get_client_by_id`, {
        client_id: id,
      })
      .then((res) => {
        if (!res.data[0]) {
          notifyError("Cliente não encontrado");
          throw new Error("Cliente não encontrado");
        }
        setClientProducts(res.data);
        handleProduct(res.data[0]);
      })
      .catch(() =>
        notifyError("Conta cancelada, não é possível realizar atendimento")
      )
      .finally(() => {
        setTimeout(() => {
          setLoadingSearchUser(false);
          if (!productInFlightRef.current) {
            searchInFlightRef.current = false;
          }
        }, 100);
      });
  }, []);

  const handleSubmit = useCallback(
    async (data) => {
      if (searchInFlightRef.current || productInFlightRef.current) return;

      if (currentDoc === "name" && data.doc.length <= 3) {
        return notifyError("A busca deve conter mais de três caracteres");
      }

      if (currentDoc === "cartao" && !user?.allowFetchByCard) {
        return notifyError("Você não tem permissão para consultar por cartão.");
      }

      searchInFlightRef.current = true;
      setLoadingSearchUser(true);

      try {
        await LogsService.create({
          action: `Usuário ${user.login} buscou ${currentDoc}: ${data.doc}`,
        });
      } catch (e) {
        console.error("Erro log:", e);
      }

      setCurrentPage(1);
      handleCleanSearch();
      setFindUser(true);
      setClientsByName({});

      const cleanDoc = toCleanDoc(data.doc);

      const ADICIONAL_HANDLERS = {
        cpf: () => api.get(`client_cpf_dependants`, { cpf: cleanDoc }),
        cartao: async () => {
          const resCard = await api.get(`client_cartao`, {
            cartao: cleanDoc,
            tipoPortador: "adicional",
          });
          if (!resCard.data?.[0]) throw new Error("Cliente não encontrado");
          return api.get(`client_cpf_dependants`, { cpf: resCard.data[0].cpf });
        },
        multSearchValue: () => {
          return api.get(`client_cpf_dependants`, { cpf: cleanDoc });
        },
      };
      const TITULAR_HANDLERS = {
        client_id: () => api.get(`get_client_by_id`, { client_id: cleanDoc }),
        name: () =>
          api.get(`client_name`, { name: data.doc, page: currentPage - 1 }),
        cartao: () =>
          api.get(`client_cartao`, {
            cartao: cleanDoc,
            tipoPortador: "titular",
          }),
        cpf: () =>
          api.get(`client_cpf`, { cpf: cleanDoc, tipoPortador: "titular" }),
        cnpj: () =>
          api.get(`client_cnpj`, { cnpj: cleanDoc, tipoPortador: "titular" }),
        rg: () =>
          api.get(`client_rg`, { rg: cleanDoc, tipoPortador: "titular" }),
        multSearchValue: () => {
          if (cleanDoc.length >= 3 && cleanDoc.length <= 9) {
            return api.get(`client_rg`, {
              rg: cleanDoc,
              tipoPortador: "titular",
            });
          }
          const route = cleanDoc.length > 11 ? "client_cnpj" : "client_cpf";
          return api.get(route, {
            [cleanDoc.length > 11 ? "cnpj" : "cpf"]: cleanDoc,
            tipoPortador: "titular",
          });
        },
      };

      try {
        let response;
        if (currentClient === "adicional") {
          response = await (
            ADICIONAL_HANDLERS[currentDoc] || ADICIONAL_HANDLERS.multSearchValue
          )();
        } else {
          response = await (
            TITULAR_HANDLERS[currentDoc] || TITULAR_HANDLERS.multSearchValue
          )();
        }

        if (currentDoc === "name") {
          const content = response.data?.content || [];
          if (content.length === 0) throw new Error("Cliente não encontrado");
          if (content.length > 1) {
            setClientsByName(content);
            setTotalByName(response.data.totalElements);
            setLoadingSearchUser(false);
            searchInFlightRef.current = false;
            return;
          }
          return await handleSelectCliente(content[0].idPortador, true);
        }

        const dataRes = Array.isArray(response.data)
          ? response.data
          : [response.data].filter(Boolean);
        if (dataRes.length === 0) throw new Error("Cliente não encontrado");

        setClientProducts(dataRes);
        handleProduct(dataRes[0]);
      } catch (error) {
        const rawMessage = error.response?.data?.message || error.message || "";
        const cleanMessage = rawMessage.split("*")?.[0] || "";

        const finalMessage = MAPPED_ERROR_MESSAGES.includes(cleanMessage)
          ? cleanMessage
          : "Cliente não encontrado";

        notifyError(finalMessage, "", false, true);

        console.error(error.response);
      } finally {
        setTimeout(() => {
          setLoadingSearchUser(false);
          if (!productInFlightRef.current) {
            searchInFlightRef.current = false;
          }
        }, 100);
      }
    },
    [
      currentDoc,
      currentClient,
      currentPage,
      user,
      handleSelectCliente,
      handleProduct,
      toCleanDoc,
    ]
  );

  const handlePageSizeChange = async (page) => {
    const { values } = formikRef.current;

    setCurrentPage(page);

    setLoadingSearchUser(true);
    setClientsByName(false);

    await api
      .get(`client_${currentDoc}`, {
        [`${currentDoc}`]:
          currentDoc === "name" ? values.doc : toCleanDoc(values.doc),
        page: page - 1,
      })
      .then((res) => {
        if (res?.data?.content?.length === 0) {
          throw new Error("Cliente não encontrado");
        }
        if (res?.data?.content?.length === 1) {
          handleSelectCliente(res?.data?.content[0].idPortador);
        } else {
          setClientsByName(res.data.content);
          setTotalByName(res.data.totalElements);
          setLoadingSearchUser(false);
        }
      })
      .catch(() => {
        notifyError("Cliente não encontrado");
        setLoadingSearchUser(false);
      });
  };


const fetchAndCheckTickets = async (clientId, clientName) => {
  const response = await api.get("get_ticket_info", {
    clientId,
  });
  
  const { hasOpenTickets, ticketsList, newTicketInfo } = response.data;

  if (hasOpenTickets) {
    setPendingTicketModalInfo({
      ticketsList,
      clientName,
    });
    return null;
  }

  return newTicketInfo; 
};

  const validateSecurityQuestions = (permissions, q1, q2, birthdayStr, dataQuestions) => {
    if (!permissions.includes("view_birth_date")) return;

    const birthdayArr = dataQuestions
      ? dataQuestions.split("-")
      : birthdayStr.split("-");

    const numQ1 = Number(q1);
    const birthMonth = Number(birthdayArr[1]); 
    
    if (Number.isNaN(numQ1) || numQ1 !== birthMonth) {
      throw new Error("Responda as perguntas corretamente");
    }

    if (birthdayArr[0] !== q2) {
      throw new Error("Responda as perguntas corretamente");
    }
  };

  const handleNewAttend = (clientInternalData, newTicketData) => {

    const decryptedBirthday = decrypt(clientFound.birthday);
    const formattedClientFound = formatClientData(clientFound);

    updateClient({
      client: {
        ...formattedClientFound,
        ...clientInternalData,
        birthday: decryptedBirthday,
        ticket: newTicketData?.ticket || clientInternalData?.ticket,
      },
      product,
      information: clientInformation,
    });

    navigate("/atendimento");
  };

  const handleContinueAttend = (ticketAtivo) => {
    const decryptedBirthday = decrypt(clientFound.birthday);
    const formattedClientFound = formatClientData(clientFound);

    updateClient({
      client: {
        ...formattedClientFound,
        birthday: decryptedBirthday,
        ticket: ticketAtivo,
      },
      product,
      information: clientInformation,
    });
    storageService.setTicketProtocol(ticketAtivo.id);
    navigate("/atendimento");
  };

  const handleAttend = useCallback(async () => {
    const decryptedBirthday = decrypt(clientFound.birthday);

    try {
      validateSecurityQuestions(permissions, q1, q2, decryptedBirthday, dataQuestions);

      setIsLoadingAttend(true);

      const formattedClientFound = formatClientData(clientFound);

      const newTicketInfo = await fetchAndCheckTickets(
        clientFound.id,
        formattedClientFound.name
      );
      if (!newTicketInfo) return;

      updateClient({
        client: {
          ...formattedClientFound,
          birthday: decryptedBirthday,
          ticket: newTicketInfo
        },
        product,
        information: clientInformation,
      });
      storageService.setTicketProtocol(newTicketInfo.id);

      setTimeout(() => {
        navigate("/atendimento");
      }, 1000);
    } catch (err) {
      notifyError(
        `${err.message ?? "Responda as perguntas corretamente"}`,
        err.message
      );
    } finally {
      setIsLoadingAttend(false);
    }
  }, [
    clientFound,
    navigate,
    product,
    q1,
    q2,
    updateClient,
    permissions,
    dataQuestions,
    clientInformation,
  ]);

  const handleTypeOfSearch = (input, hasCardSearch, setFieldValue) => {
    const cleanValue = input.replace(/[^a-zA-Z0-9À-ÿ\s]/g, "");
    const isAlpha =
      /^[a-zA-ZÀ-ÿ\s]+$/.test(cleanValue) && cleanValue.length > 0;
    const cleanAlfanumericInput = input.replace(/[^a-zA-Z0-9]/g, "");
    const isTitularAlfanumericCnpj =
      currentClient === "titular" &&
      cleanAlfanumericInput.length === 14 &&
      /^[0-9A-Za-z]{14}$/.test(cleanAlfanumericInput) &&
      /[a-zA-Z]/.test(cleanAlfanumericInput);

    setInputValue(input);
    setFieldValue("doc", cleanValue);

    if (cleanValue.length === 0) {
      return;
    }

    if (currentDoc === "client_id") return;

    if (isTitularAlfanumericCnpj) {
      setCurrentDoc("cnpj");
    } else if (isAlpha) {
      setCurrentDoc("name");
    } else if (cleanValue.length >= 15 && hasCardSearch) {
      setCurrentDoc("cartao");
    } else {
      setCurrentDoc("multSearchValue");
    }
  };

  useEffect(() => {
    if (isPasswordExpired?.isPwdExpired) {
      notifyInfo(
        isPasswordExpired.firstLogin
          ? "Redefinição de senha de primeiro acesso"
          : "Senha expirada para o prazo de 90 dias. Por favor insira uma nova senha."
      );
      openModalAlterarSenhaisOpen();
      setEditPassword(true);
    } else {
      setEditPassword(false);
    }
  }, [isPasswordExpired, openModalAlterarSenhaisOpen]);

  const getCardStatusStyle = (cardStatus) => {
    switch (cardStatus) {
      case "ATIVO": {
        return "active-card";
      }
      default: {
        return "blocked-card";
      }
    }
  };

  const clientCpf = useMemo(() => client?.client?.cpf, [client]);

  const fetchSolicitations = useCallback(
    async (pagination = {}, filters = {}, sorter = {}) => {
      try {
        const { current, pageSize } = pagination;

        const {
          ticket_protocol,
          client_name,
          status,
          priority,
          type,
          id,
          user_name,
          attendant_name,
        } = filters;

        setLoadingRequestTable(true);
        const response = await SolicitationService.list({
          client_cpf: clientCpf,
          id,
          status,
          priority,
          type,
          user_name,
          attendant_name,
          ticket_protocol: ticket_protocol ? ticket_protocol[0] : undefined,
          client_name: client_name ? client_name[0] : undefined,
          limit: pageSize,
          page: current,
          sorter,
        });
        setDataSource(response);

        const { data } = response;

        if (!current) {
          const filterByUser = data?.filter(
            (item) =>
              item.attendant_user_id === user?.id && item.status === "ACTIVE"
          );

          setDataRequestByUser(filterByUser.slice(-3));
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingRequestTable(false);
      }
    },
    [clientCpf, user]
  );

  const handleSubmitFormModal = async (value) => {
    handleTab("multSearchValue");

    handleTypeOfSearch(
      formatCPF(value),
      user?.allowFetchByCard,
      formikRef.current.setFieldValue
    );

    setTimeout(() => {
      setModalRequestHomeOpen(false);
      formikRef.current.submitForm();
    }, 1000);
  };

  useEffect(() => {
    fetchPermissions();
  }, [fetchPermissions]);

  useEffect(() => {
    fetchPermissionsManagement();
  }, [fetchPermissionsManagement]);

  useEffect(() => {
    fetchPushPermissions();
  }, [fetchPushPermissions]);

  useEffect(() => {
    fetchSolicitations();
  }, [user, fetchSolicitations]);

  return (
    <>
      <PopupService isOpen={hasPopupActive} onClose={handleClosePopup} />
      {modalAlterarSenhaisOpen && (
        <ResetPasswordModal onCancel={closeModalAlterarSenhaisOpen} />
      )}

      {!isPasswordExpired?.isPwdExpired && (
        <Style.WrapperSearchUserMeet
          viewSolicitation={!permissions.includes("view_solicitation")}
        >
          <div className="user-meet__header">
            <p>Buscar cliente para atender</p>
          </div>

          <div className="user-meet__content">
            <div className="item-select__user">
              <p className="title">Cliente:</p>

              <div className="item-select__options">
                <Style.DocButton
                  selected={currentClient === "titular"}
                  onClick={() => handleTypeClient("titular")}
                >
                  <p>Titular</p>
                </Style.DocButton>
                <Style.DocButton
                  selected={currentClient === "adicional"}
                  onClick={() => handleTypeClient("adicional")}
                >
                  <p>Adicional</p>
                </Style.DocButton>
              </div>
            </div>
            <div className="item-select__user">
              <p className="title">Tipo:</p>

              <div className="item-select__options scroll">
                <Style.DocButton
                  scroll
                  selected={
                    currentDoc === "multSearchValue" ||
                    currentDoc === "cpf" ||
                    currentDoc === "cnpj"
                  }
                  onClick={() => handleTab("multSearchValue")}
                >
                  <p>Documento</p>
                </Style.DocButton>
                {currentClient === "titular" &&
                  permissions?.includes("personal_data") && (
                    <Style.DocButton
                      scroll
                      selected={currentDoc === "client_id"}
                      onClick={() => handleTab("client_id")}
                    >
                      <p>ID Cliente</p>
                    </Style.DocButton>
                  )}

                {permissions?.includes("permission_search_by_name") &&
                  currentClient !== "adicional" && (
                    <Style.DocButton
                      scroll
                      selected={currentDoc === "name"}
                      onClick={() => handleTab("name")}
                    >
                      <p>Nome</p>
                    </Style.DocButton>
                  )}
              </div>
            </div>
            <div className="item-select__user">
              <p className="title">
                {currentDoc === "name" ? "Nome:" : "Número:"}
              </p>

              <div className="input-search">
                <Formik
                  initialValues={{ doc: "" }}
                  validationSchema={schema}
                  onSubmit={handleSubmit}
                  autoComplete="off"
                  innerRef={formikRef}
                >
                  {({ setFieldValue }) => (
                    <Form>
                      <div className="item-input">
                        {currentDoc === "name" ? (
                          <>
                            <Field name="doc">
                              {({ field, meta }) => (
                                <input
                                  label="Usuário"
                                  placeholder={placeholderText}
                                  className={
                                    meta.touched && meta.error ? "error" : null
                                  }
                                  {...field}
                                  autoComplete="off"
                                  disabled={loadingSearchUser || loadingClient}
                                />
                              )}
                            </Field>
                          </>
                        ) : (
                          <>
                            <Field name="doc">
                              {({ field, form }) => {
                                const formatAlfanumericCnpjMask = (coreRaw) => {
                                  const x = String(coreRaw ?? "")
                                    .replace(/[^a-zA-Z0-9]/g, "")
                                    .substring(0, 14);
                                  const n = x.length;
                                  if (n === 0) return "";
                                  if (n <= 2) return x;
                                  if (n <= 5) return `${x.slice(0, 2)}.${x.slice(2)}`;
                                  if (n <= 8)
                                    return `${x.slice(0, 2)}.${x.slice(2, 5)}.${x.slice(5)}`;
                                  if (n <= 12)
                                    return `${x.slice(0, 2)}.${x.slice(2, 5)}.${x.slice(5, 8)}/${x.slice(8)}`;
                                  return `${x.slice(0, 2)}.${x.slice(2, 5)}.${x.slice(5, 8)}/${x.slice(8, 12)}-${x.slice(12)}`;
                                };

                                const getMaskedValue = (val) => {
                                  if (
                                    currentDoc === "client_id" ||
                                    currentDoc === "name"
                                  )
                                    return val;

                                  const cleanAlfanumericMask = val.replace(
                                    /[^a-zA-Z0-9]/g,
                                    ""
                                  );
                                  const restrictedCleanAlfanumericMask =
                                    cleanAlfanumericMask.substring(0, 14);
                                  if (
                                    currentClient === "titular" &&
                                    restrictedCleanAlfanumericMask.length > 0 &&
                                    /^[0-9A-Za-z]*$/.test(
                                      restrictedCleanAlfanumericMask
                                    ) &&
                                    /[a-zA-Z]/.test(
                                      restrictedCleanAlfanumericMask
                                    )
                                  ) {
                                    return formatAlfanumericCnpjMask(
                                      restrictedCleanAlfanumericMask
                                    );
                                  }

                                  const clean = val.replace(/\D/g, "");

                                  const limit = user?.allowFetchByCard
                                    ? 19
                                    : 14;
                                  const restrictedClean = clean.substring(
                                    0,
                                    limit
                                  );

                                  if (restrictedClean.length <= 11) {
                                    return restrictedClean
                                      .replace(/(\d{3})(\d)/, "$1.$2")
                                      .replace(/(\d{3})(\d)/, "$1.$2")
                                      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                                  }

                                  if (restrictedClean.length <= 14) {
                                    return restrictedClean
                                      .replace(/^(\d{2})(\d)/, "$1.$2")
                                      .replace(
                                        /^(\d{2})\.(\d{3})(\d)/,
                                        "$1.$2.$3"
                                      )
                                      .replace(/\.(\d{3})(\d)/, ".$1/$2")
                                      .replace(/(\d{4})(\d)/, "$1-$2");
                                  }

                                  return restrictedClean
                                    .replace(/(\d{4})(?=\d)/g, "$1 ")
                                    .substring(0, 23);
                                };

                                return (
                                  <input
                                    name={field.name}
                                    onBlur={field.onBlur}
                                    placeholder={placeholderText}
                                    className={
                                      form.touched.doc && form.errors.doc
                                        ? "error"
                                        : ""
                                    }
                                    value={getMaskedValue(inputValue)}
                                    onChange={(e) => {
                                      handleTypeOfSearch(
                                        e.target.value,
                                        user?.allowFetchByCard,
                                        form.setFieldValue
                                      );
                                    }}
                                    autoComplete="off"
                                    disabled={loadingSearchUser || loadingClient}
                                  />
                                );
                              }}
                            </Field>
                          </>
                        )}
                        <ErrorMessage
                          name="doc"
                          className="error-msg"
                          component="div"
                        />
                      </div>

                      <div className="user-login__btn">
                        <button
                          type="submit"
                          disabled={
                            editPassword || loadingSearchUser || loadingClient
                          }
                        >
                          <IoMdSearch />
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </Style.WrapperSearchUserMeet>
      )}

      {findUser ? (
        <Style.WrapperInfosUser>
          <div className="infos-search__header">
            <p>Encontrar cliente</p>
            <button type="button" onClick={handleCleanSearch}>
              <Can permission="view_solicitation">Listar solicitações</Can>
              <IoMdClose />
            </button>
          </div>

          <Style.WrapperCardsUserSelect>
            {loadingSearchUser && (
              <div className="user-info__loading">
                <LoadingElevaty />
              </div>
            )}

            {clientsByName.length > 0 ? (
              <>
                <div className="scroll-names-desk">
                  {clientsByName.length > 0 &&
                    clientsByName.map((item) => {
                      return (
                        <div
                          className="user-card-select__clientname"
                          key={item.idPortador}
                        >
                          <div className="client-name__name">
                            <FaUser />
                            <p>{item.nomePortador}</p>
                          </div>
                          <div className="client-name__document">
                            <p>
                              <span>ID:</span>
                              {item.idPortador}
                            </p>
                          </div>
                          <div className="client-name__btn">
                            <button
                              type="button"
                              onClick={() =>
                                handleSelectCliente(item.idPortador)
                              }
                            >
                              <IoIosArrowForward /> Selecionar
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>
                <Style.CenterDivPagination>
                  <Pagination
                    current={currentPage}
                    onChange={(page) => {
                      handlePageSizeChange(page);
                    }}
                    pageSize={50}
                    total={totalByName}
                    showSizeChanger={false}
                  />
                </Style.CenterDivPagination>
              </>
            ) : (
              <>
                {clientProducts && clientProducts.length > 0 && (
                  <>
                    <div className="user-card-select__header">
                      <p>Produtos:</p>
                    </div>
                    <div className="user-card-select__grid">
                      {clientProducts.map((card) => (
                        <div
                          className={`user-card-select__item ${cardSelected?.id === card.id ? "active" : ""
                            }`}
                          onClick={() => {
                            handleProduct(card);
                          }}
                          key={card.id}
                        >
                          <div className="icon-check">
                            <BsCheckCircleFill color="#2A56A5" />
                          </div>

                          <div className="user-card-select__item-header">
                            <CgCreditCard /> <p>{card.desc_prod}</p>
                          </div>

                          <div className="user-card-select__item-content">
                            <ul>
                              {card.cartoes.map((cartao) => (
                                <li key={cartao.id}>
                                  {cartao.numeroMascarado} (
                                  {cartao.virtual ? "Virtual" : "Físico"})
                                  <p
                                    className={`${getCardStatusStyle(
                                      cartao.status
                                    )} status`}
                                  >
                                    {cartao.status.replace(/_/g, " ")}
                                  </p>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {showClient && (
                  <>
                    {loadingClient ? (
                      <div className="user-info__loading">
                        <LoadingElevaty />
                      </div>
                    ) : (
                      <>
                        {clientFound && (
                          <>
                            <div className="user-info__search">
                              <div className="user-info__search-item">
                                <div className="user-info__search-item__header">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.5rem",
                                    }}
                                  >
                                    <FaUser />
                                    {clientFound.socialName && (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Nome Social:
                                      </span>
                                    )}
                                  </div>
                                  <p>
                                    {clientFound.socialName
                                      ? capitalize(clientFound.socialName)
                                      : capitalize(clientFound.name)}
                                  </p>

                                  <div className="tags">
                                    <p>#{clientFound?.id}</p>
                                    <span
                                      className={customerStatus(
                                        clientFound.statusCliente
                                      ).toLocaleLowerCase()}
                                    >
                                      {customerStatus(
                                        clientFound.statusCliente
                                      )}
                                    </span>
                                    {clientFound.statusCliente === "B" &&
                                      clientFound.ultimoMotivoBloqueioCliente && (
                                      <Can permission="permission_view_block_type">
                                        <Tooltip
                                          title={
                                            clientFound.ultimoMotivoBloqueioCliente
                                          }
                                        >
                                          <MdInfoOutline />
                                        </Tooltip>
                                      </Can>
                                    )}
                                  </div>
                                </div>
                                <Can permission="permission_view_data_client_search">
                                  <div className="user-info__search-infos">
                                    {clientFound.cpf && (
                                      <div className="item-user-info">
                                        <p>
                                          <span>CPF</span>:{" "}
                                          {clientFound.cpf.replace(
                                            /(\d{3})(\d{3})(\d{3})(\d{2})/,
                                            "$1.$2.$3-$4"
                                          )}
                                        </p>
                                      </div>
                                    )}
                                    {clientFound.rg &&
                                      clientFound?.rg !== "undefined" && (
                                        <div className="item-user-info">
                                          <p>
                                            <span>RG</span>: {clientFound.rg}
                                          </p>
                                        </div>
                                      )}
                                    {clientFound.email && (
                                      <div className="item-user-info">
                                        <p className="email">
                                          <span>E-mail</span>:{" "}
                                          {clientFound.email}
                                        </p>
                                      </div>
                                    )}
                                    {clientFound.socialName && (
                                      <div className="item-user-info">
                                        <p className="email">
                                          <span>Nome:</span>:{" "}
                                          {capitalize(clientFound.name)}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </Can>
                              </div>
                            </div>

                            <div className="user-info__form">
                              <div className="user-info__form-align">
                                {permissions.includes("view_birth_date") && (
                                  <div className="user-info__form-left">
                                    <div className="user-info__form-input">
                                      <p>
                                        Mês de nascimento do{" "}
                                        <b>{currentClient}</b>:
                                      </p>
                                      <ReactInputMask
                                        placeholder="Ex.: 01"
                                        mask="99"
                                        maskChar=""
                                        name="q1"
                                        autoComplete="off"
                                        onChange={handleQ1}
                                        data-testid="input_mes_nascimento_atendimento"
                                      />
                                    </div>
                                    <div className="user-info__form-input">
                                      <p>
                                        Ano de nascimento do{" "}
                                        <b>{currentClient}</b>:
                                      </p>
                                      <ReactInputMask
                                        placeholder="Ex.: 2022"
                                        mask="9999"
                                        maskChar=""
                                        name="q2"
                                        autoComplete="off"
                                        onChange={handleQ2}
                                        data-testid="input_ano_nascimento_atendimento"
                                      />
                                    </div>
                                  </div>
                                )}

                                <div className="user-info__form-right">
                                  <DSButton
                                    type="submit"
                                    onClick={handleAttend}
                                    icon={<IoIosArrowForward />}
                                    isIconAfter
                                    buttonText="Atender"
                                    buttonType="primary"
                                    dataTestId="button-init-attend"
                                    style={{
                                      height: "40px",
                                      borderRadius: "4px",
                                      width: "100%",
                                    }}
                                    isLoading={isLoadingAttend}
                                    disabled={isLoadingAttend}
                                    isDisabled={isLoadingAttend}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Style.WrapperCardsUserSelect>
          {!loadingClient &&
            showClient &&
            clientFound &&
            clientFound.fatura_fechada && (
              <InvoiceInfo
                text="Valor da última fatura:"
                dataVencimento={clientFound.fatura_fechada.dataVencimento}
                valorTotal={clientFound.fatura_fechada.valorTotal}
                possuiPagamentoMinimo={
                  clientFound.fatura_fechada.possuiPagamentoMinimo
                }
                valorMinimo={clientFound.fatura_fechada.valorPagamentoMinimo}
              />
            )}
          {!loadingClient &&
            showClient &&
            clientFound &&
            clientFound.information &&
            clientFound.information.faturasFuturas &&
            !!clientFound.information.faturasFuturas.length && (
              <InvoiceInfo
                text="Valor da fatura atual:"
                dataVencimento={
                  clientFound.information.faturasFuturas[0].dataVencimento
                }
                valorTotal={clientFound.information.faturasFuturas[0].valor}
                possuiPagamentoMinimo={false}
              />
            )}
        </Style.WrapperInfosUser>
      ) : (
        <Can permission="view_solicitation">
          <Style.WrapperInfosUser>
            <div className="infos-search__header">
              <p>
                <strong>Meus tickets</strong>{" "}
                {dataRequestByUser?.length ? (
                  <>
                    - {dataRequestByUser?.length}{" "}
                    {dataRequestByUser?.length === 1
                      ? "Ticket em atendimento"
                      : "Tickets em atendimento"}
                  </>
                ) : null}
              </p>
            </div>

            <Style.WrapperItemRequest>
              {loadingRequestTable ? (
                <div className="user-card-select__loading">
                  <LoadingElevaty />
                </div>
              ) : (
                <>
                  {dataRequestByUser?.length ? (
                    <>
                      {dataRequestByUser?.map((item) => (
                        <Style.DivItemRequest key={Math.random()}>
                          <div className="divitem-content__left">
                            <p className="divitem-content__protocol">
                              <strong>#{item?.id}</strong> - Protoc.{" "}
                              {item?.ticket_protocol}
                            </p>
                            <p className="divitem-content__title">
                              <strong>{item?.type?.name}</strong>
                            </p>
                            <p className="divitem-content__infos">
                              <span className="divitem-content__user">
                                <FaRegUserCircle />
                                {item?.client_name}
                              </span>
                              <span className="divitem-content__user">
                                <RiTimerLine />
                                {formatDateTime(item?.created_at)}
                              </span>
                              <span className="divitem-content__user">
                                <FaListOl />
                                {TRANSLATE_PRIORITY[item?.priority]?.label}
                              </span>
                              <span className="divitem-content__user">
                                {TRANSLATE_STATUS[item?.status].label ===
                                  "Pendente" ? (
                                  <FiClock />
                                ) : null}
                                {TRANSLATE_STATUS[item?.status].label ===
                                  "Cancelado" ? (
                                  <FiAlertTriangle />
                                ) : null}
                                {TRANSLATE_STATUS[item?.status].label ===
                                  "Ativo" ? (
                                  <FaRegCheckCircle />
                                ) : null}
                                {TRANSLATE_STATUS[item?.status].label ===
                                  "Resolvido" ? (
                                  <FaRegCheckCircle />
                                ) : null}
                                {TRANSLATE_STATUS[item?.status].label}
                              </span>
                            </p>
                          </div>
                          <div className="divitem-content__right">
                            <button
                              type="button"
                              onClick={() => handleOpenModalRequestHome(item)}
                            >
                              Ver <MdKeyboardArrowRight />
                            </button>
                          </div>
                        </Style.DivItemRequest>
                      ))}
                    </>
                  ) : (
                    <div className="user-card-select__empty">
                      <span>
                        <FiAlertTriangle />
                        <p>Não há tickets de solicitações</p>
                      </span>
                    </div>
                  )}
                </>
              )}
            </Style.WrapperItemRequest>
          </Style.WrapperInfosUser>
        </Can>
      )}

      {!findUser ? (
        <Can permission="view_solicitation">
          <TableRequestsHome
            loadingRequestTable={loadingRequestTable}
            dataSource={dataSource}
            handleOpenModalRequestHome={handleOpenModalRequestHome}
            fetchSolicitations={fetchSolicitations}
          />
        </Can>
      ) : null}

      {modalRequestHomeOpen ? (
        <ModalRequestHome
          dataModalRequest={dataModalRequest}
          onClose={() => setModalRequestHomeOpen(false)}
          handleSubmitFormModal={handleSubmitFormModal}
          fetchSolicitations={fetchSolicitations}
        />
      ) : null}
      <LimitModal />
      {!!pendingTicketModalInfo && (
        <PendingTicketInfoModal
          onClose={() => setPendingTicketModalInfo(null)}
          ticketDate={pendingTicketModalInfo.created_at ?? ""}
          attendantName={pendingTicketModalInfo.created_by_username ?? ""}
          ticketProtocol={pendingTicketModalInfo?.protocol ?? ""}
          clientId={clientFound?.id}
          clientName={clientFound?.name}
          ticketsList={pendingTicketModalInfo.ticketsList || []}
          onContinue={handleContinueAttend}
          onCreateNew={handleNewAttend}
        />
      )}
    </>
  );
}

export default SearchUser;
